import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "@/lib/motion";
import { CheckCircle2 } from "lucide-react";

const ABOUT_IMG = "https://images.unsplash.com/photo-1681949103006-70066fb25dfe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBkaXZlcnNlJTIwdGVhbSUyMG9mZmljZSUyMG1lZXRpbmd8ZW58MHx8fHwxNzgzMzM3MDY5fDA&ixlib=rb-4.1.0&q=85&w=1000";

const POINTS = [
  "Experienced marketing professionals",
  "Data-driven campaigns",
  "Transparent reporting",
  "Personalized strategies",
  "Dedicated customer support",
];

export default function About() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [40, -40]);

  return (
    <section id="about" ref={ref} className="py-24 lg:py-32 bg-white scroll-mt-20" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        {/* image */}
        <Reveal className="relative order-2 lg:order-1">
          <div className="relative rounded-[2rem] overflow-hidden shadow-2xl shadow-slate-200">
            <motion.img style={{ y }} src={ABOUT_IMG} alt="Digital Madhuraa team collaborating" className="w-full h-[440px] object-cover scale-110" />
          </div>
        </Reveal>

        {/* copy */}
        <div className="order-1 lg:order-2">
          <Reveal>
            <span className="overline text-[var(--dm-purple)]">About Digital Madhuraa</span>
            <h2 className="font-head font-extrabold tracking-tighter text-4xl sm:text-5xl text-slate-900 mt-4 leading-[1.05]">
              We turn ambitious brands into <span className="text-gradient">market leaders</span>
            </h2>
            <p className="mt-6 text-lg text-slate-600 leading-relaxed">
              Digital Madhuraa is a results-driven digital marketing agency focused on helping businesses grow through creativity, strategy, and measurable performance. We blend bold ideas with hard data to deliver growth you can actually see.
            </p>
          </Reveal>

          <div className="mt-8 grid sm:grid-cols-2 gap-4">
            {POINTS.map((p, i) => (
              <Reveal key={p} delay={i * 0.08}>
                <div className="flex items-center gap-3 rounded-xl border border-slate-100 bg-[var(--dm-alt)] px-4 py-3.5">
                  <CheckCircle2 size={20} className="text-[var(--dm-purple)] shrink-0" />
                  <span className="font-medium text-slate-800 text-[0.95rem]">{p}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
